(function (angular) {
    'use strict';

    angular.module('widget')

        /**
         *
         */
        .factory('widgetConfigService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';
                    var fac = {
                        getConfig: getConfig,
                        updateConfig: updateConfig,
                        deleteConfig: deleteConfig
                    };

                    return fac;

                    /**
                     * GET "/apispaces/{apiSpaceId}/widget/config"
                     * @param {string} apiSpaceId - the api space Id
                     */
                    function getConfig(apiSpaceId) {

                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/widget/config")
                            .then(getConfigComplete)
                            .catch(getConfigFailed);

                        function getConfigComplete(response) {
                            return response.data;
                        }

                        function getConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }


                    /**
                     * PUT "/apispaces/{apiSpaceId}/widget/config"
                     * @param {string} apiSpaceId - the api space Id
                     * @param {string} updateData - data to update
                     */
                    function updateConfig(apiSpaceId, updateData) {

                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/widget/config", updateData)
                            .then(updateConfigComplete)
                            .catch(updateConfigFailed);

                        function updateConfigComplete(response) {
                            return response.data;
                        }

                        function updateConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }


                    /**
                     * * DELETE "/apispaces/{apiSpaceId}/widget/config"
                     * * @param {string} apiSpaceId - the api space Id
                     * */
                    function deleteConfig(apiSpaceId, teamId) {

                        return $http.delete(urlBase + "/apispaces/" + apiSpaceId + "/widget/config")
                            .then(deleteConfigComplete)
                            .catch(deleteConfigFailed);

                        function deleteConfigComplete(response) {
                            return response.data;
                        }

                        function deleteConfigFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                }]);
})(window.angular);
